import { render, staticRenderFns } from "./simplifyOwnerTransactionCar.vue?vue&type=template&id=2a106d06&scoped=true"
import script from "./simplifyOwnerTransactionCar.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerTransactionCar.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerTransactionCar.vue?vue&type=style&index=0&id=2a106d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a106d06",
  null
  
)

export default component.exports